const STAMPED_THUMB_BASE = "https://cdn.stamped.io/tr:h-180:/uploads/photos/"
const STAMPED_FULL_BASE = "https://cdn.stamped.io/uploads/photos/"

export const getReviewImageFilenames = (review) => {
    if (!review?.imagesFileName) return []

    return review.imagesFileName
        .split(",")
        .map((filename) => filename.trim())
        .filter(Boolean)
}

export const buildReviewGallery = (reviews) => {
    const list = Array.isArray(reviews) ? reviews : []
    const images = []
    const offsetByReviewIndex = {}

    list.forEach((item, reviewIndex) => {
        const review = item?.review
        const filenames = getReviewImageFilenames(review)

        if (filenames.length === 0) return

        offsetByReviewIndex[reviewIndex] = images.length

        filenames.forEach((filename, imageIndex) => {
            images.push({
                filename,
                thumbSrc: `${STAMPED_THUMB_BASE}${filename}`,
                fullSrc: `${STAMPED_FULL_BASE}${filename}`,
                review,
                reviewIndex,
                imageIndex,
            })
        })
    })

    return { images, offsetByReviewIndex }
}
